export const defaultState = {
  appData: null,
  appSupportEndingDialogSeen: false,
};

export const SET_APP_VERSION_DATA = 'SET_APP_VERSION_DATA';
export const SET_APP_SUPPORT_ENDING_DIALOG_SEEN =
  'SET_APP_SUPPORT_ENDING_DIALOG_SEEN';

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_APP_VERSION_DATA:
      return { ...state, appData: action.payload };
    case SET_APP_SUPPORT_ENDING_DIALOG_SEEN:
      return { ...state, appSupportEndingDialogSeen: action.payload };
    default:
      return state;
  }
};

export const sGetAppVersionData = (state) => state.appVersionData?.appData;
export const sGetAppSupportEndingDialogSeen = (state) =>
  state.appVersionData?.appSupportEndingDialogSeen;
